/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsState } from '../permissions.slice';

export default function setMemberRoleFilter(state: PermissionsState, action: PayloadAction<string>) {
  state.membersRoleFilter = action.payload;
}
